export const TOOL_NAME = 'pdfme (https://pdfme.com/)';
